import { View } from "react-native"

export default function Spacer() {
  return (
    <View className="grow" /> // Expands to fill remaining space on current axis
  )
}
